import { useRef, useState } from "react";
import { Clapperboard } from "lucide-react";
import { CARTOON } from "@/data/characters";

const CHAPTERS = [
  { t: 0, label: "Hi, everybody!" },
  { t: 10, label: "Soapy & Splashy" },
  { t: 20, label: "Uh-oh, Germy!" },
  { t: 30, label: "Wash him away!" },
  { t: 40, label: "Clean hands!" },
];

export const CartoonSection = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(0);
  const jump = (i) => {
    ref.current.currentTime = CHAPTERS[i].t;
    ref.current.play().catch(() => {});
  };
  const onTime = () => {
    const t = ref.current.currentTime;
    setActive(CHAPTERS.reduce((a, c, i) => (t >= c.t ? i : a), 0));
  };
  return (
    <section id="watch" data-testid="video-section" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-16 sm:px-8">
      <p className="flex items-center gap-2 font-display text-lg font-semibold text-[#1e9bf0]"><Clapperboard className="h-5 w-5" /> Episode 1</p>
      <h2 className="font-display text-4xl font-bold text-[#0b4fa3] sm:text-5xl">Meet Handy & Friends!</h2>
      <p className="mt-3 max-w-2xl text-slate-600">Handy says hello, Soapy and Splashy join the fun, and sneaky Germy learns why we always wash our hands.</p>
      <div className="mt-10 overflow-hidden rounded-[2.5rem] border-[6px] border-white bg-[#0b4fa3] shadow-[0_30px_60px_rgba(11,79,163,0.25)]">
        <video ref={ref} data-testid="cartoon-video" src={CARTOON.src} poster="/cartoon/poster.jpg" controls playsInline preload="metadata" onTimeUpdate={onTime} className="aspect-[3/2] w-full bg-black object-contain" />
      </div>
      <div className="no-scrollbar -mx-4 mt-6 flex gap-3 overflow-x-auto px-4 pb-2">
        {CHAPTERS.map((c, i) => (
          <button key={c.t} data-testid={`cartoon-chapter-${i + 1}`} onClick={() => jump(i)}
            className={`min-h-[52px] shrink-0 rounded-full px-5 font-display text-base font-semibold transition-colors ${active === i ? "bg-[#0b4fa3] text-white" : "bg-white text-[#0b4fa3] hover:bg-sky-100"}`}>
            {i + 1}. {c.label}
          </button>
        ))}
      </div>
    </section>
  );
};
